import Util from '@/helper/Utility';

export function UserInfoModel() {
    this.firstname = '';
    this.lastname = '';
    this.contact_number = '';
    this.birthdate = null;
    this.gender = '';
    this.email = '';

    this.getParamsRegister = function () {
        const params = {

        };

        return Util.cleanObjectEmptyStr(params);
    };

    this.getParamsUpdateProfile = function () {
        const params = {

        };

        return Util.cleanObjectEmptyStr(params);
    };
}